"use client";
import {axiosInstance} from "@/app/api";

const getvehicles = async (requestData: any): Promise<any> => {
  const url = "/api/fleet/vehicles/list";
  return await axiosInstance().post(url, requestData);
};

const getexpensesummary = async (
  userid: any,
  requestdata: any
): Promise<any> => {
  const url = "/api/fleet/expense/summary?loginUserId=" + userid;
  return await axiosInstance().post(url, requestdata);
};

const getoverallexpense = async (
  userid: any,
  requestdata: any
): Promise<any> => {
  const url = "/api/fleet/allExpenses/list";
  return await axiosInstance().post(url, requestdata);
};

const getgroupvehicle = async (userid: any, requestdata: any): Promise<any> => {
  const url = "/api/fleet/allExpenses/vehicleGrouped?loginUserId=" + userid;
  return await axiosInstance().post(url, requestdata);
};

const getgroupdate = async (userid: any, requestdata: any): Promise<any> => {
  const url = "/api/fleet/allExpenses/dateGrouped?loginUserId=" + userid;
  return await axiosInstance().post(url, requestdata);
};

const getgroupexpense = async (userid: any, requestdata: any): Promise<any> => {
  const url = "/api/fleet/allExpenses/expenseGrouped?loginUserId=" + userid;
  return await axiosInstance().post(url, requestdata);
};

const getfuelexpense = async (userid: any, requestdata: any): Promise<any> => {
  const url = "/api/fleet/fuelExpense/list";
  return await axiosInstance().post(url, requestdata);
};

const getmaintance = async (userid: any, requestdata: any): Promise<any> => {
  const url = "/api/fleet/maintenanceExpense/list";
  return await axiosInstance().post(url, requestdata);
};

const getmiscellaneous = async (
  userid: any,
  requestdata: any
): Promise<any> => {
  const url = "/api/fleet/miscExpenses/list";
  return await axiosInstance().post(url, requestdata);
};

const addfuelexpense = async (userid: any, data: any): Promise<any> => {
  var url: string = "/api/fleet/fuelExpense/add?loginUserId=" + userid;
  return await axiosInstance().post(url, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

const updatefuelexpense = async (userid: any, data: any): Promise<any> => {
  var url: string = "/api/fleet/fuelExpense/edit?loginUserId=" + userid;
  return await axiosInstance().post(url, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

const deletefuelexpense = async (
  userid: any,
  requestdata: any
): Promise<any> => {
  const url = "/api/fleet/fuelExpense/delete?loginUserId=" + userid;
  return await axiosInstance().post(url, requestdata);
};

const getexpenseview = async (userid: any, requestdata: any): Promise<any> => {
  const url = "/api/fleet/allExpenses/readById?loginUserId=" + userid;
  return await axiosInstance().post(url, requestdata);
};

const addmaintenanceexpense = async (userid: any, data: any): Promise<any> => {
  var url: string = "/api/fleet/maintenanceExpense/add?loginUserId=" + userid;
  return await axiosInstance().post(url, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

const updatemaintenanceexpense = async (
  userid: any,
  data: any
): Promise<any> => {
  var url: string = "/api/fleet/maintenanceExpense/edit?loginUserId=" + userid;
  return await axiosInstance().post(url, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

const deletemaintenanceexpense = async (
  userid: any,
  requestdata: any
): Promise<any> => {
  const url = "/api/fleet/maintenanceExpense/delete?loginUserId=" + userid;
  return await axiosInstance().post(url, requestdata);
};

const addmiscellaneousexpense = async (
  userid: any,
  data: any
): Promise<any> => {
  var url: string = "/api/fleet/miscExpenses/add?loginUserId=" + userid;
  return await axiosInstance().post(url, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

const updatemiscellaneousexpense = async (
  userid: any,
  data: any
): Promise<any> => {
  var url: string = "/api/fleet/miscExpenses/edit?loginUserId=" + userid;
  return await axiosInstance().post(url, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

const deletemiscellaneousexpense = async (
  userid: any,
  requestdata: any
): Promise<any> => {
  const url = "/api/fleet/miscExpenses/delete?loginUserId=" + userid;
  return await axiosInstance().post(url, requestdata);
};

const documentupload = async (userid: any, data: any): Promise<any> => {
  var url: string = "/api/fleet/document/add?loginUserId=" + userid;
  return await axiosInstance().post(url, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

const deletedocument = async (userid: any, requestdata: any): Promise<any> => {
  const url = "/api/fleet/document/delete?loginUserId=" + userid;
  return await axiosInstance().post(url, requestdata);
};

const deleteExpense = async (userid: any, requestdata: any): Promise<any> => {
  const url = "/api/fleet/expenses/delete?loginUserId=" + userid;
  return await axiosInstance().post(url, requestdata);
};

export const ExpenseService = {
  getvehicles,
  getexpensesummary,
  getoverallexpense,
  getgroupvehicle,
  getgroupdate,
  getgroupexpense,
  getfuelexpense,
  getmaintance,
  getmiscellaneous,
  addfuelexpense,
  updatefuelexpense,
  deletefuelexpense,
  getexpenseview,
  addmaintenanceexpense,
  updatemaintenanceexpense,
  deletemaintenanceexpense,
  addmiscellaneousexpense,
  updatemiscellaneousexpense,
  deletemiscellaneousexpense,
  documentupload,
  deletedocument,
  deleteExpense
};
